import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsClient } from '~/hooks';

type IUseClientDetailHeader = (id: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
  };
};

/**
 * クライアント詳細ヘッダーのコンポーネントフック
 *
 * @param id - クライアントID（Screen 層でパース・検証済みの数値）
 */
export const useClientDetailHeader: IUseClientDetailHeader = id => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsClient({ threeLetterCode, clientId: id });

  return {
    state: {
      data,
    },
  };
};
